export default "<input type=\"text\" [(ngModel)]=\"currentValue\" (ngModelChange)=\"updateCurrentValue($event)\" />\n"